import { render, staticRenderFns } from "./ModalServerToken.vue?vue&type=template&id=03281d14"
import script from "./ModalServerToken.vue?vue&type=script&lang=js"
export * from "./ModalServerToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports